import React, { useState, useEffect } from "react";
import { Card, CardMedia, CardContent, Typography, Box, Button } from "@mui/material";
import api from "../api/api";
import "./news.css?v=1.0";

const News = () => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    api.get("/news")
      .then(response => setNews(response.data))
      .catch(error => console.error("Erreur lors du chargement des actualités:", error));
  }, []);

  return (
    <Box className="news-sidebar">
      {news.map((newsItem) => (
        <Card key={newsItem._id} className="news-card">
          <Box className="news-image-container">
            <CardMedia
              component="img"
              height="200"
              image={newsItem.attachments[0]}
              alt="Image de l'actualité"
              className="news-image"
            />
            <Box className="news-overlay">
              <Typography variant="h6" className="news-title">{newsItem.title}</Typography>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-line', textAlign: 'justify', textJustify: 'inter-word', hyphens: 'auto' }} className="news-description">{newsItem.description}</Typography>
            </Box>
          </Box>
          <CardContent className="news-footer">
            <Button href={newsItem.link} target="_blank" rel="noopener noreferrer" className="voir-plus-btn">
              En savoir Plus
            </Button>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default News;
